export default __webpack_public_path__ + "static/media/donut-unicorn.2be8daac.jpg";